import React from 'react';
import AboutImage from '../../images/about.svg'
import how from '../../images/icons/how.svg'

function AboutBody(props) {
    return (
        <div className='flex flex-col'>
            <div className='text-[32px] leading-[41px] lg:text-[64px] lg:leading-[73px] text-start px-5 lg:px-20 grid grid-cols-2 py-10'>
                <div className='col-span-2 lg:col-span-1 font-[500] '>
                    Partnering with<br/> 
                    <span className="whitespace-nowrap">
                    Businesses for <span className="text-[#008B39]">Growth</span>
                    </span>
                </div>
            </div>
            <div className='overflow-hidden bg-[#000000] lg:mb-10'><img className="h-auto max-h-[720px] w-full object-cover object-center" src={AboutImage} alt="About Yebokenny" /></div>
            <div className='flex flex-col px-5 lg:px-20 my-5 lg:my-10 space-y-5'>
                <div className='grid grid-cols-8 gap-x-10'>
                    <div className='col-span-8 lg:col-span-2 text-[#0E0E0E] text-[32px] lg:text-[44px] font-[500] text-start'>Who we are</div>
                    <div className='col-span-8 lg:col-span-6 flex flex-col space-y-3 text-start'>
                        <span className='text-[#737373] text-[16px]'>Yebokenny is an innovative digital platform that brings the 
                            traditional practice of word-of-mouth referrals into the modern age. 
                            It offers a dynamic space for customers to share their genuine experiences 
                            and recommendations about various products, services, places, and more. 
                            This platform is the ultimate destination for unbiased, user-generated 
                            recommendations that assist customers in making informed decisions and 
                            uncovering hidden treasures. Yebokenny is here to revolutionize the way 
                            businesses flourish and succeed in today's interconnected world.
                        </span>
                        <span className='font-semibold'>Positive referencing through business excellence</span>
                        <span className=''>More than just a local listing, your free Business Profile lets you manage how your business appears on YeboKenny Search.</span>
                    </div>
                </div>
                <div className='grid grid-cols-8 gap-x-10 items-center pb-7'>
                    <div className='col-span-8 lg:col-span-2 text-[#0E0E0E] text-[32px] lg:text-[44px] font-[500] text-start'>Our Mission</div>
                    <div className='col-span-8 lg:col-span-6 flex flex-col space-y-3 text-start'>
                        <span className='text-[#737373] text-[16px]'>
                            Our innovative platform empowers businesses of all sizes to tap 
                            into and transform the potential of authentic word-of-mouth marketing. 
                            We make it effortless, adaptable, and game-changing for their business expansion.
                        </span>
                    </div>
                </div>
                <div className='pb-10 lg:pb-20'>
                    <div className="relative w-full h-0" style={{ paddingBottom: '43.25%' }}>
                        <iframe
                        className="absolute top-0 left-0 w-full h-full lg:h-[500px] rounded-[8px]"
                        src="https://www.youtube.com/embed/LtgUaxGIrc8"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        ></iframe>
                    </div>
                </div>
                <div className='bg-[#F2F9F1] rounded-[8px]'>
                    <div className='text-[#0E0E0E] text-[48px] font-[500] lg:pt-10'>How it works</div>
                    <div className='grid grid-cols-6 p-5 lg:p-10 lg:pb-20 gap-x-5 gap-y-5 lg:gap-y-0'>
                        <div className='col-span-6 lg:col-span-2 rounded-[8px] flex flex-col space-y-4 bg-white text-start p-3 py-7'>
                            <span><img src={how} /></span>
                            <div className='flex flex-col'>
                                <span className='text-[#0E0E0E] text-[24px] lg:text-[24px] font-[500]'>Step 1</span>
                                <span className='text-[#737373] text-[14px] font-[400]'>Create a YeboKenny account by signing up with your email address and other information.</span>
                            </div>
                        </div>
                        <div className='col-span-6 lg:col-span-2 rounded-[8px] flex flex-col space-y-4 bg-white text-start p-3 py-7'>
                            <span><img src={how} /></span>
                            <div className='flex flex-col'>
                                <span className='text-[#0E0E0E] text-[24px] lg:text-[24px] font-[500]'>Step 2</span>
                                <span className='text-[#737373] text-[14px] font-[400]'>Create your listing on our YeboKenny portal by providing accurate information about your business.</span>
                            </div>
                        </div>
                        <div className='col-span-6 lg:col-span-2 rounded-[8px] flex flex-col space-y-4 bg-white text-start p-3 py-7'>
                            <span><img src={how} /></span>
                            <div className='flex flex-col'>
                                <span className='text-[#0E0E0E] text-[24px] lg:text-[24px] font-[500]'>Step 3</span>
                                <span className='text-[#737373] text-[14px] font-[400]'>Receive recommendations through your unique business listing page.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mb-10'></div>
            </div>
        </div>
    );
}

export default AboutBody;